import Vue from 'vue'
import App from 'components/App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'

Vue.use(VueAxios, axios);

Vue.filter('unix2date', function (timestamp) {
    return moment.unix(timestamp).format('YYYY-MM-DD hh:mm');
});

export default new Vue({
    ...App
})



// WEBPACK FOOTER //
// ./C:/Users/schulz/web/steam-achievements2/src/app.js